import { render } from "./Animal.vue?vue&type=template&id=00633194&scoped=true"
import script from "./Animal.vue?vue&type=script&lang=js"
export * from "./Animal.vue?vue&type=script&lang=js"

import "./Animal.vue?vue&type=style&index=0&id=00633194&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00633194"]])

export default __exports__